import { useMemo, useState } from 'react';
import { NavLink } from 'react-router-dom';
import { NAV_ITEMS } from '@/constants/routes';
import { useAuth, useTranslation } from '@/contexts';
import { canSeeSidebarItem, pathToSidebarItem } from '@/features/auth';
import { logoutWebAdmin } from '@/features/auth/logoutWebAdmin';
import styles from './Sidebar.module.css';

export function Sidebar() {
  const { role } = useAuth();
  const { t } = useTranslation();

  const visibleItems = useMemo(
    () =>
      NAV_ITEMS.filter((item) => {
        const sidebarItem = pathToSidebarItem(item.path);
        return sidebarItem ? canSeeSidebarItem(role, sidebarItem) : false;
      }),
    [role],
  );

  const [isSigningOut, setIsSigningOut] = useState(false);

  const handleSignOut = () => {
    if (isSigningOut) return;
    setIsSigningOut(true);
    void logoutWebAdmin().finally(() => setIsSigningOut(false));
  };

  return (
    <aside className={styles.sidebar}>
      <div className={styles.brand}>
        <span className={styles.brandMark}>U1</span>
        <div className={styles.brandText}>
          <span className={styles.brandName}>Unit 1</span>
          <span className={styles.brandSubtitle}>{t('sidebar.brandSubtitle')}</span>
        </div>
      </div>

      <nav className={styles.nav} aria-label={t('sidebar.mainNavigation')}>
        <ul className={styles.navList}>
          {visibleItems.map((item) => (
            <li key={item.path}>
              <NavLink
                to={item.path}
                end={item.path === '/'}
                className={({ isActive }) =>
                  isActive ? `${styles.navLink} ${styles.navLinkActive}` : styles.navLink
                }
              >
                {t(`nav.${item.labelKey}`)}
              </NavLink>
            </li>
          ))}
        </ul>
      </nav>

      <button
        type="button"
        className={styles.signOutBtn}
        onClick={handleSignOut}
        disabled={isSigningOut}
      >
        {t('auth.signOut')}
      </button>
    </aside>
  );
}
